module.exports = __webpack_public_path__ + "img/forestgreen@2x.b7e5d5f.webp";